/**
 * Created by rouven on 12.07.17.
 */
var getSessionId = function () {
    var jsId = document.cookie.match(/PHPSESSID=[^;]+/);
    if (jsId) {
        if (jsId instanceof Array)
            jsId = jsId[0].substring(10);
        else
            jsId = jsId.substring(10);
    }
    return jsId;
};
export default getSessionId;
